import { Box, Stack, styled } from '@mui/material';
import SelectMenu from '../../forms/SelectMenu';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TextInput from '../../forms/TextInput';
import { WorkflowDetailSource } from '../../../data/models/workflow.model';
import { lowerFirst } from 'lodash';
import { WorkflowStepFormData } from '../../../data/workflow-form.model';

const PREFIX = 'WorkflowStepPublishEventAction';

const classes = {
  pubEventContainer: `${PREFIX}-pubEventContainer`,
  nameSelect: `${PREFIX}-nameSelect`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.pubEventContainer}`]: {
    gap: theme.spacing(3),
  },
  [`& .${classes.nameSelect}`]: {
    marginTop: theme.spacing(1),
    width: 330,
  },
}));

export default function WorkflowStepPublishEventAction() {
  const { t } = useTranslation('common');

  const { control, formState } = useFormContext<WorkflowStepFormData>();

  const detailSourceValues = Object.values(WorkflowDetailSource).map(
    (value) => ({
      key: t(`workflows.${lowerFirst(value)}`),
      value,
    }),
  );

  const validateJSON = (value: string) => {
    try {
      JSON.parse(value);
      return true;
    } catch (e) {
      return t('workflows.templateError');
    }
  };

  const selectedDetailSource = useWatch({
    control,
    name: 'publishEvent.detailSource',
  });

  return (
    <StyledBox>
      <Stack direction="column" className={classes.pubEventContainer}>
        <TextInput
          name="publishEvent.name"
          label={t('workflows.eventName')}
          control={control}
          required
          rules={{ required: t('common.requiredField') }}
          errors={formState.errors}
        />

        <SelectMenu
          name={`publishEvent.detailSource`}
          label={t('workflows.eventContent')}
          className={classes.nameSelect}
          values={detailSourceValues}
          valueAttr="value"
          labelAttr="key"
          control={control}
          required
          errorMessage={formState.errors.publishEvent?.detailSource?.message}
          rules={{ required: t('common.requiredField') }}
        />

        {selectedDetailSource === WorkflowDetailSource.Template && (
          <TextInput
            name="publishEvent.detailTemplate"
            label={t('workflows.template')}
            control={control}
            required
            multiline
            inputProps={{ minRows: 4 }}
            rules={{
              required: t('common.requiredField'),
              validate: validateJSON,
            }}
            errors={formState.errors}
          />
        )}
      </Stack>
    </StyledBox>
  );
}
